import { FieldModel, ProgramBenchmarkName, ProgramTask, TaskDataTraitStatus } from '@cibo/core'
import { LimingCellDisplay } from '@cibo/landmanager'
import { TraitCellContainer } from './TraitCellContainer'

interface LimingCellProps {
  value: any
  task: ProgramTask<{ benchmarkName: ProgramBenchmarkName; traits: TaskDataTraitStatus[] }>
  year: number
  selectedField?: FieldModel
  onSaveSuccess?: () => void
}

export const LimingCell = ({
  value,
  task,
  year,
  selectedField,
  onSaveSuccess,
}: LimingCellProps) => {
  return (
    <TraitCellContainer
      value={value}
      task={task}
      selectedField={selectedField}
      year={year}
      traitId="liming"
      onSaveSuccess={onSaveSuccess}
    >
      <LimingCellDisplay value={value} />
    </TraitCellContainer>
  )
}
